import {TextField} from "@mui/material";
import {forwardRef} from "react";

const PrimaryInput = forwardRef(({sx, ...props}: any, ref) => {
    return (
        <TextField
            ref={ref}
            fullWidth
            size="small"
            type="text"
            inputProps={{
                sx: {
                    fontSize: 13,
                    bgcolor: 'white'
                }
            }}
            InputLabelProps={{
                shrink: true,
                sx: {
                    fontSize: 16
                }
            }}
            sx={{
                ".MuiInputBase-root": {
                    borderRadius: 0
                },
                ...sx
            }}
            {...props}
        />
    )
})

export default PrimaryInput
